module.exports = __webpack_public_path__ + "img/bom4.4d90caf2.png";